import { PriceAfterChangeValues, PriceAfterChangeResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculatePriceAfterChange(
  values: PriceAfterChangeValues,
  t?: ToolsTranslations['priceAfterChange']
): PriceAfterChangeResult {
  const { initial, percent } = values;

  if (initial < 0) return { finalPrice: null, isValid: false, message: t?.invalid.initial };
  if (!isFinite(percent)) return { finalPrice: null, isValid: false, message: t?.invalid.percent };

  // If initial is zero, final is always zero regardless of percent
  if (initial === 0) return { finalPrice: 0, isValid: true };

  const factor = 1 + (percent / 100);
  const finalPrice = Math.round((initial * factor) * 100) / 100;

  if (!isFinite(finalPrice)) return { finalPrice: null, isValid: false, message: t?.invalid.generic };

  return { finalPrice, isValid: true };
}
